export const excelFileNames = {
  TAB_SURVEY_ASSETS: 'רשימת נכסים דומים.xlsx',
  TAB_SURVEY_ASSETS_TEMPLATE: 'תבנית למילוי נכסים דומים.xlsx',
  TAB_FIRM: 'רשימת דוחות המשרד.xlsx',
  TAB_SHARED: 'רשימת דוחות ממאגר שיתופי.xlsx',
  TAB_TAX_AUTHORITY: 'רשות המיסים.xlsx',
};
